import {FC, useEffect, useState} from "react";
import {useParams} from "react-router";
import {LanguageContext, useNewLanguageContext} from "../store/languageContext.ts";
import AppBarWithLanguageSelect from "../organisms/AppBarWithLanguageSelect.tsx";
import ContentArea from "../atoms/ContentArea.tsx";
import {Column, FlexSpace} from "../atoms/Layout.tsx";
import HugeTitle from "../atoms/HugeTitle.tsx";
import IssueReportingChat from "../templates/IssueReportingChat.tsx";
import {TRANSLATIONS} from "../store/translations.ts";
import {getSitePublicInfo, PublicSiteInfo} from "../api/site.ts";


const IssueReportingPage: FC = () => {
    const {siteId, siteIdCode} = useParams();
    const languageContext = useNewLanguageContext();
    const translations = TRANSLATIONS[languageContext.language.languageCode] ?? TRANSLATIONS['en'];
    const [site, setSite] = useState<PublicSiteInfo | null>(null);

    useEffect(() => {
        getSitePublicInfo(siteIdCode!).then(setSite);
    }, []);

    return <LanguageContext.Provider value={languageContext}>
        <AppBarWithLanguageSelect title={site?.name ?? undefined}/>
        <ContentArea>
            <Column gap="20" grow>
                <FlexSpace/>
                <Column>
                    <HugeTitle gradient>{translations.mainTitle.highlight}</HugeTitle>
                    <HugeTitle>{translations.mainTitle.subtitle}</HugeTitle>
                </Column>
                <IssueReportingChat siteId={siteId!} settings={site?.feedbackPageSettings}/>
            </Column>
        </ContentArea>
    </LanguageContext.Provider>
}

export default IssueReportingPage;